import * as React from 'react';

export default function NewsArrow(props) {
  const {color} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25.174}
      height={25.347}
      viewBox="0 0 25.174 32.347"
    >
      <defs>
        <filter
          id="news-arrow-a"
          x={0}
          y={0}
          width={25.174}
          height={32.347}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={3} result="blur" />
          <feFlood floodColor="#f5ff00" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g filter="url(#news-arrow-a)">
        <path
          data-name="Path 4116"
          d="m8.996 6 6.612 5.871a1.781 1.781 0 0 1 0 2.6l-6.612 5.871 3.14-6.273v-1.79Z"
          fill={color}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}
